import React, { useEffect, useState } from 'react';
import "bootstrap/dist/css/bootstrap.rtl.min.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './App.css';
import './assets/main.css'

import axios from "axios";
import { Setting, webData } from "./helper/setting";
import { useLocation } from "react-router-dom";
import { clearLogin } from "./helper/function";
import SEO from "./helper/seo";
import universal from 'react-universal-component';
import ChatBot from "./container/chatbot/chatbot";

const MainComponentsHeader = universal(import("./layout/mainComponents/Header"))
const WebRouter = universal(import("./helper/router"))
const MainComponentsFooter = universal(import("./layout/mainComponents/Footer"))

function App() {
    const [loading, setloading] = useState(true)
    const [meta, setmeta] = useState({})
    const location = useLocation()

    useEffect(() => {
        if (window.webengage) {
            window.webengage.options('webpush.registerServiceWorker', true);
        }
    }, []);
    const getData = () => {
        axios.get(Setting.apiUrl + 'OptionApi/Get',
            {
                method: "get",
                headers: {
                    'Authorization': 'Basic ' + localStorage.getItem("token")
                }
            },
        ).then(async function (response) {
            if (response.data.Status == "Ok") {
                if (response.data.Slider.length != 0) {
                    if (webData.SliderData.length == 0) {
                        response.data.Slider.forEach((v: never) => {
                            webData.SliderData.push(v)
                        })
                    }
                }
                if (response.data.Category.length != 0) {
                    if (webData.Category.length == 0) {

                        response.data.Category.forEach((v: never) => {
                            webData.Category.push(v)
                        })
                    }
                }
                if (webData.WebSetting.length == 0) {
                    Object.entries(response.data.Setting).map((v: any, k: any) => {
                        try {
                            webData.WebSetting[v[0]] = JSON.parse(v[1])
                        } catch (e) {
                            webData.WebSetting[v[0]] = v[1]
                        }
                    })
                }

                if (response.data.Profit.length != 0) {
                    if (webData.Profit.length == 0) {
                        response.data.Profit.forEach((v: never) => {
                            webData.Profit.push(v)
                        })
                    }
                }

                if (response.data.Testimonial.length != 0) {
                    if (webData.Testimonial.length == 0) {
                        response.data.Testimonial.forEach((v: never) => {
                            webData.Testimonial.push(v)
                        })
                    }
                }

                if (response.data.Setting.title != null && response.data.Setting.title != "") {
                    Setting.systemName = response.data.Setting.title
                    document.body.title = response.data.Setting.title
                }

                if (response.data.User.length == 0) {
                    clearLogin()
                } else {
                    Object.entries(response.data.User).map((v: any, k: any) => {
                        localStorage.setItem(v[0], v[1])
                        webData.User[v[0]] = v[1]
                    })

                    if (window.webengage) {
                        window.webengage.user.login(response.data.User.tpId);


                        const Phone: string = response.data.User.PrimaryPhone
                        window.webengage.user.login(response.data.User.tpId);
                        if (response.data.User.FirstName) {
                            window.webengage.user.setAttribute('we_first_name', response.data.User.FirstName);
                        }
                        if (response.data.User.LastName) {
                            window.webengage.user.setAttribute('we_last_name', response.data.User.LastName);
                        }
                        if (response.data.User.Email) {
                            window.webengage.user.setAttribute('we_email', response.data.User.Email);
                        }
                        if (Phone) {
                            window.webengage.user.setAttribute('we_phone', (Phone.length > 10 && !Phone.includes("+")) ? "+" + Phone : Phone);
                        }
                        if (response.data.User.City) {
                            window.webengage.user.setAttribute('we_city', response.data.User.City);
                        }
                    }

                }

                setmeta({
                    title: "Family Capital", // Always use Family Capital instead of API title
                    description: response.data.Setting.description || "Family Capital trading platform",
                    canonical: window.location.href,
                    meta: {
                        charset: 'utf-8',
                        name: {
                            keywords: response.data.Setting.keyword || "trading, forex, Family Capital"
                        },
                        property: {
                            "og:title": "Family Capital",
                            "og:description": response.data.Setting.description || "Family Capital trading platform",
                            "og:site_name": "Family Capital",
                            "og:url": window.location.href
                        }
                    }
                })

                setloading(false)
            } else {
                //getData()
            }
        }).catch(function (error) {
            console.log("OptionApi/Get Error:", error);

            // Set default data when API fails
            setmeta({
                title: "Family Capital",
                description: "Family Capital trading platform",
                canonical: window.location.href,
                meta: {
                    charset: 'utf-8',
                    name: {
                        keywords: "trading, forex, Family Capital"
                    },
                    property: {
                        "og:title": "Family Capital",
                        "og:description": "Family Capital trading platform",
                        "og:site_name": "Family Capital",
                        "og:url": window.location.href
                    }
                }
            });

            // Initialize webData for offline mode
            if (!webData.WebSetting || webData.WebSetting.length === 0) {
                webData.WebSetting = {
                    title: "Family Capital",
                    description: "Family Capital trading platform",
                    logo: "images/logo",
                    footerdescription: "العائلة كابيتال للاستثمار - منصة تداول موثوقة",
                    email: "info@fa-capital.co",
                    tel: "+966123456789",
                    facebook: "#",
                    instagram: "#",
                    youtube: "#",
                    twitter: "#",
                    googleplay: "#",
                    appstore: "#",
                    home_section9: {
                        title: "ابدأ التداول الآن",
                        btn: "سجل الآن",
                        link: "/regisration"
                    }
                };
            }

            if (!webData.Category) webData.Category = [];
            if (!webData.SliderData) webData.SliderData = [];
            if (!webData.Testimonial) webData.Testimonial = [];
            if (!webData.Profit) webData.Profit = [];

            setloading(false);
        });
    }

    useEffect(() => {
        window.addEventListener('scroll', function () {
            var el = document.querySelector('.header') as HTMLElement
            if (el) {
                var headerHeight = el.offsetHeight;
                if (window.scrollY > headerHeight) {
                    const masthead = document.getElementById('masthead');
                    if (masthead) masthead.classList.add('fixed-header');
                } else {
                    const masthead = document.getElementById('masthead');
                    if (masthead) masthead.classList.remove('fixed-header');
                }
            }
        });

        getData();
    }, [])

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 100)
    }, [location.pathname])

    useEffect(() => {
        if (location.state) {
            setmeta({
                title: Setting.systemName + " - " + (location.state ? location.state.title : ""),
                canonical: window.location.href,
                meta: {
                    charset: 'utf-8',
                    name: {},
                    property: {
                        "og:title": Setting.systemName + (location.state ? " - " + location.state.title : ""),
                        "og:url": window.location.href
                    }
                }
            })
        }
    }, [location.pathname])

    return (
        <div className="App">
            {!loading && (
                <SEO prop={meta} >
                    <MainComponentsHeader />
                    <WebRouter />
                    <MainComponentsFooter />
                </SEO>
            )}
        </div>
    );
}

export default App;
